module.exports = [
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "Eurocube",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Bath spout",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Backflow protection combination",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Inlet, pop-up and waste-system",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673000/640/27673000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Hand shower 4+ sprays, spray plate night time grey",
		"textblock_1st_text": "27673000",
		"textblock_2nd_text": "دش يدوي GROHE Power&Soul، مقاس 130 مم، بمعدل 9,5 لترات في الدقيقة",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27673000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27699000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27699000/640/27699000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27699000",
		"textblock_2nd_text": "دش Euphoria Cube Stick من GROHE، الدش اليدوي، نمط رذاذ واحد",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27699000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27734000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27734000/640/27734000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27734000",
		"textblock_2nd_text": "مجموعة GROHE Power&Soul Cosmopolitan مع دش يدوي (130 مم)، عامود دش (900 مم) وخرطوم دش (1750 مم)، 9.5 لترات في الدقيقة",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27734000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "مجموعة GROHE Power&Soul مع دش يدوي (130 مم)، عامود دش (900 مم) وخرطوم دش (1750 مم)، 9.5 لترات في الدقيقة",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26459000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26459000/640/26459000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Head shower set 380 mm, 3 sprays",
		"textblock_1st_text": "26459000",
		"textblock_2nd_text": "طقم دش الرأس GROHE Euphoria 260 SmartControl المزوّد بثلاثة نطاقاتٍ للرذاذ. دش رأس موفِّر للمياه قطره 260 مم وذراع GROHE Rainshower طولها (380 مم) مزوَّدة بطبقة من الكروم. سهل التركيب والتنظيف. ومصنوع في ألمانيا",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26459000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475000/640/26475000.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Head shower set 430 mm, 2 sprays",
		"textblock_1st_text": "26475000",
		"textblock_2nd_text": "طقم دش الرأس GROHE Rainshower 310 SmartActive المزود بخيارين للرذاذ. دش رأس مثبت في الجدار بطول 310 مم مزود بذراع دش بطول 400 مم بلمسة نهائية من الكروم ومستدير الشكل. ومصنوع في ألمانيا",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26475000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Head shower set 430 mm, 2 sprays",
		"textblock_1st_text": "26475LS0",
		"textblock_2nd_text": "طقم دش الرأس GROHE Rainshower 310 SmartActive المزود بخيارين للرذاذ. دش رأس مثبت في الجدار بطول 310 مم مزود بذراع دش بطول 400 مم بلمسة نهائية من الكروم ولوحة الرذاذ الأبيض ومستدير الشكل. ومصنوع في ألمانيا",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26477000",
		"textblock_2nd_text": "طقم دش الرأس GROHE Rainshower 310 SmartActive المزود بخيارين للرذاذ. دش رأس مثبت في السقف بطول 310 مم مزود بذراع دش بطول 142 مم بلمسة نهائية من الكروم ومستدير الشكل. ومصنوع في ألمانيا",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26477LS0",
		"textblock_2nd_text": "طقم دش الرأس GROHE Rainshower 310 SmartActive المزود بخيارين للرذاذ. دش رأس مثبت في السقف بطول 310 مم مزود بذراع دش بطول 142 مم بلمسة نهائية من الكروم ولوحة الرذاذ الأبيض ومستدير الشكل. ومصنوع في ألمانيا",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Head shower set 430 mm, 2 sprays",
		"textblock_1st_text": "26479LS0",
		"textblock_2nd_text": "طقم دش الرأس GROHE Rainshower 310 SmartActive CUBE المزود بخيارين للرذاذ. دش رأس مثبت في الجدار بطول 310 مم مزود بذراع دش بطول 400 مم بلمسة نهائية من الكروم ولوحة الرذاذ الأبيض ومربع الشكل. ومصنوع في ألمانيا",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26481000",
		"textblock_2nd_text": "طقم دش الرأس GROHE Rainshower 310 SmartActive CUBE المزود بخيارين للرذاذ. دش رأس مثبت في السقف بطول 310 مم مزود بذراع دش بطول 142 مم بلمسة نهائية من الكروم ومربع الشكل. ومصنوع في ألمانيا",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Combi shower system with safety mixer, exposed/concealed",
		"textblock_1st_text": "26443000",
		"textblock_2nd_text": "نظام دش GROHE Rainshower SmartControl 360 DUO Combi مزود بترموستات. مطلي بالكروم، وصديق للبيئة، ومصنوع في ألمانيا: دش ذو رأس طوله 360 مم ومزود برذاذ GROHE TrioMassage، ودش يدوي طوله 115 مم مزود برذاذَين.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Combi shower system with safety mixer, exposed/concealed",
		"textblock_1st_text": "26443LS0",
		"textblock_2nd_text": "نظام دش GROHE Rainshower SmartControl 360 DUO Combi مزود بترموستات. مطلي بالكروم، وصديق للبيئة، ومصنوع في ألمانيا: دش ذو رأس طوله 360 مم (لوحة رذاذ بيضاء) ومزود برذاذ GROHE TrioMassage، ودش يدوي طوله 115 مم ومزود برذاذَين.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Concealed body for exposed/concealed variants",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26452000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26452000/640/26452000.jpg",
		"headline": "Tempesta System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "26452000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26452000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26453000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26453000/640/26453000.jpg",
		"headline": "Tempesta Cosmopolitan System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "26453000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26453000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Side shower 1 spray",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "نظام دش GROHE Rainshower 400 مزود بترموستات",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wall hand shower holder",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "نظام دش GROHE Rainshower 210 مزود بترموستات",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wall hand shower holder",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "نظام دش GROHE Rainshower 210 مزود بمحول",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27635000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27635000/640/27635000.jpg",
		"headline": "Rainshower Icon 150",
		"subheadline": "Hand shower 2 sprays",
		"textblock_1st_text": "27635000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27635000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G233",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with Bath Safety Mixer for wall mounting",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "نظام دش GROHE Rainshower 210 مزود بترموستات وصنبور حمام",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254LS0/640/26254LS0.jpg",
		"headline": "Rainshower Duo 360",
		"subheadline": "Head shower set 450 mm, 2 sprays",
		"textblock_1st_text": "26254LS0",
		"textblock_2nd_text": "طقم دش الرأس GROHE Rainshower 360 DUO المطلي بالكروم، والمصنوع في ألمانيا: دش ذو رأس طوله 360 مم (لوحة رذاذ بيضاء) ومزود برذاذ GROHE TrioMassage، وذراع دش طولها 450 مم.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26254LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Rough-in box for head shower set",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Shower rail set 1 spray",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27741000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27741000/640/27741000.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Wall holder set 4+ sprays",
		"textblock_1st_text": "27741000",
		"textblock_2nd_text": "مجموعة GROHE Power&Soul Cosmopolitan مع دش يدوي (115 مم)، خرطوم دش (1250 مم) وحامل دش يدوي",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27741000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27750000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27750000/640/27750000.jpg",
		"headline": "Power&Soul 160",
		"subheadline": "Shower rail set 4+ sprays",
		"textblock_1st_text": "27750000",
		"textblock_2nd_text": "مجموعة GROHE Power&Soul مع دش يدوي (مقاس 160 مم)، عامود دش (مقاس 900 مم) وخرطوم دش (مقاس 1750 مم)، بمعدل 9.5 لترات في الدقيقة",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27750000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Shower rail set 2 sprays",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Shower rail set 2 sprays",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "مجموعة GROHE Power&Soul مع دش يدوي (115 مم)، عامود دش (900 مم) وخرطوم دش (1750 مم)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Shower rail, 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27705000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27705000/640/27705000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Head shower 1 spray",
		"textblock_1st_text": "27705000",
		"textblock_2nd_text": "رأس دش GROHE Euphoria Cube 150 مع Rain Spray، مطلي بالكروم، صُنع في ألمانيا، مع خاصية توفير المياه",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26224001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26224001/640/26224001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Shower system with single lever mixer for wall mounting",
		"textblock_1st_text": "26224001",
		"textblock_2nd_text": "نظام الدش GROHE Tempesta Cosmopolitan 210 مع خلاط بمقبض فردي، ودش رأس طول قطره 210 مم، بالإضافة إلى دش يدوي بنمطَي رذاذ مطليٍّ بالكروم ويبلغ طوله 100 مم. سهل التركيب والتنظيف. تصميم هندسي ألماني",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26224001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "نظام دش GROHE Rainshower SmartControl 360 DUO Exposed مزود بترموستات. ومطلي بالكروم، وصديق للبيئة، ومصنوع في ألمانيا، وملحق به دش ذو رأس طوله 360 مم ومزود برذاذ GROHE TrioMassage، بالإضافة إلى دش يدوي طوله 115 مم ومزود برذاذَين.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "26250LS0",
		"textblock_2nd_text": "نظام دش GROHE Rainshower SmartControl 360 DUO Exposed مزود بترموستات. مطلي بالكروم، وصديق للبيئة، ومصنوع في ألمانيا، وملحق به دش ذو رأس طوله 360 مم (لوحة رذاذ بيضاء) ومزود برذاذ GROHE TrioMassage، بالإضافة إلى دش يدوي طوله 115 مم ومزود برذاذَين.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26254000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26254000/640/26254000.jpg",
		"headline": "Rainshower Duo 360",
		"subheadline": "Head shower set 450 mm, 2 sprays",
		"textblock_1st_text": "26254000",
		"textblock_2nd_text": "طقم دش رأس GROHE Rainshower 360 DUO. مطلي بالكروم، ومصنوع في ألمانيا: دش رأس طوله 360 مم ومزود برذاذ GROHE TrioMassage، وذراع دش طولها 450 مم.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26254000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 422 mm, 1 spray",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26174LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26174LS0/640/26174LS0.jpg",
		"headline": "Power&Soul Cosmopolitan",
		"subheadline": "Wall holder set 4+ sprays",
		"textblock_1st_text": "26174LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26174LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Shower outlet elbow 1/2\"",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "يمتاز منفذ الدش الكوعي Eurocube بحامل جداري، ولمسة نهائية من الكروم مع أسلوب هندسي ألماني.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Shower system with single lever mixer for wall mounting",
		"textblock_1st_text": "23147001",
		"textblock_2nd_text": "نظام دش GROHE Euphoria Cube XXL مزود بخلّاط بمقبض فردي ومطلي بطبقة من الكروم وبتصميم هندسي ألماني، ومُلحق به دش رأس معدني طوله 230 مم، بالإضافة إلى دش يدوي مزود برذاذ واحد.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27296002",
		"textblock_2nd_text": "نظام الدش GROHE Euphoria 260 المزوَّد بترموستات، ودش رأس بثلاثة أنماط من الرذاذ يبلغ طول قطره 260 مم، بالإضافة إلى دش يدوي بثلاثة أنماط من الرذاذ مطليًّ بالكروم ويبلغ طوله 110 مم. سهل التركيب والتنظيف. تصميم هندسي ألماني",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Hand shower 1 spray",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Shower rail set 1 spray",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with safety mixer and side showers",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "نظام دش GROHE Rainshower 210 مزود بترموستات وفوهات هيكل متدفقة",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27389001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27389001/640/27389001.jpg",
		"headline": "Tempesta System 200",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "27389001",
		"textblock_2nd_text": "نظام دش GROHE New Tempesta 200 FLEX مزود بمحوّل ومتوافق مع جميع الصمامات الموجودة لتحسين الأداء بسهولة. مصنوع في ألمانيا ومزود برأس دش ثنائي الرذاذ طول قطره 200، بالإضافة إلى دش يدوي رباعي الرذاذ طوله 100 مم.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27389001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27420001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27420001/640/27420001.jpg",
		"headline": "Euphoria 180",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27420001",
		"textblock_2nd_text": "نظام دش GROHE Euphoria 180 مزود بترموستات ومطلي بطبقة من الكروم وذو تصميم هندسي ألماني، إلى جانب أنه مُلحق به دش رأس يبلغ طول قطره 180 مل، بالإضافة إلى دش يدوي ثلاثي الرذاذ طوله 110 مم.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27420001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421001/640/27421001.jpg",
		"headline": "Euphoria System 180",
		"subheadline": "Shower system with diverter <br />for wall mounting",
		"textblock_1st_text": "27421001",
		"textblock_2nd_text": "نظام الدش Euphoria 180 من GROHE مزود بمحوّل، معدل استهلاك قدره 9.5 لترات/دقيقة توفره تقنية GROHE EcoJoy",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27421001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "نظام دش GROHE Rainshower 310 مزود بترموستات",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "نظام دش GROHE Rainshower 210 مزود بترموستات",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "نظام دش GROHE Rainshower 310 مزود بترموستات",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Inlet, pop-up and waste-system",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29118000",
		"textblock_2nd_text": "ترموستات SuperSteel للدش، أحادي الصمام ويتميز بالتركيب المخفي. وهو دائري الشكل، ومزوّد بطبقة من الكروم، ومصنوع في ألمانيا بواسطة GROHE. يتسم بأنه صديق للبيئة ومزوَّد بميزة الأمان.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29119000",
		"textblock_2nd_text": "ترموستات Grohtherm SmartControl للدش أو الحمام، ثنائي الصمام للتركيب المخفيّ. وهو دائري الشكل، ومزوّد بطبقة من الكروم، ومصنوع في ألمانيا بواسطة GROHE. يتسم بأنه صديق للبيئة ومزوَّد بميزة الأمان.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves <br />and integrated shower holder",
		"textblock_1st_text": "29120000",
		"textblock_2nd_text": "ترموستات Grohtherm SmartControl للدش أو الحمام، ثنائي الصمام وذو وحدة دش مدمجة، للتركيب المخفيّ. وهو دائري الشكل، ومزوّد بطبقة من الكروم، ومصنوع في ألمانيا بواسطة GROHE. يتسم بأنه صديق للبيئة ومزوَّد بميزة الأمان.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29121000",
		"textblock_2nd_text": "ترموستات Grohtherm SmartControl للدش أو الحمام، ثلاثي الصمامات للتركيب المخفيّ. وهو دائري الشكل، ومزوّد بطبقة من الكروم، ومصنوع في ألمانيا بواسطة GROHE. يتسم بأنه صديق للبيئة ومزوَّد بميزة الأمان.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29123000",
		"textblock_2nd_text": "ترموستات SuperSteel للدش، أحادي الصمام ويتميز بالتركيب المخفي. وهو مربع الشكل، ومزوّد بطبقة من الكروم، ومصنوع في ألمانيا بواسطة GROHE. يتسم بأنه صديق للبيئة ومزوَّد بميزة الأمان.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29124000",
		"textblock_2nd_text": "ترموستات Grohtherm SmartControl للدش أو الحمام، ثنائي الصمام للتركيب المخفيّ. وهو مربع الشكل، ومزوّد بطبقة من الكروم، ومصنوع في ألمانيا بواسطة GROHE. يتسم بأنه صديق للبيئة ومزوَّد بميزة الأمان.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves <br />and integrated shower holder",
		"textblock_1st_text": "29125000",
		"textblock_2nd_text": "ترموستات Grohtherm SmartControl للدش أو الحمام، ثنائي الصمام وذو وحدة دش مدمجة، للتركيب المخفيّ. وهو مربع الشكل، ومزوّد بطبقة من الكروم، ومصنوع في ألمانيا بواسطة GROHE. يتسم بأنه صديق للبيئة ومزوَّد بميزة الأمان.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29126000",
		"textblock_2nd_text": "ترموستات Grohtherm SmartControl للدش أو الحمام، ثلاثي الصمامات للتركيب المخفيّ. وهو مربع الشكل، ومزوّد بطبقة من الكروم، ومصنوع في ألمانيا بواسطة GROHE. يتسم بأنه صديق للبيئة ومزوَّد بميزة الأمان.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29153LS0",
		"textblock_2nd_text": "ترموستات SuperSteel للدش، أحادي الصمام ويتميز بالتركيب المخفي. شكل مربع أبيض كبياض القمر مصنوع في ألمانيا بواسطة GROHE. يتسم بأنه صديق للبيئة ومزوَّد بميزة الأمان.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29156LS0",
		"textblock_2nd_text": "ترموستات Grohtherm SmartControl للدش أو الحمام، ثنائي الصمام للتركيب المخفيّ. شكل مربع أبيض كبياض القمر مصنوع في ألمانيا بواسطة GROHE. يتسم بأنه صديق للبيئة ومزوَّد بميزة الأمان.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29157LS0",
		"textblock_2nd_text": "ترموستات Grohtherm SmartControl للدش أو الحمام، ثلاثي الصمامات للتركيب المخفيّ. شكل مربع أبيض كبياض القمر مصنوع في ألمانيا بواسطة GROHE. يتسم بأنه صديق للبيئة ومزوَّد بميزة الأمان.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26052000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26052000/640/26052000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26052000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26052000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053000/640/26053000.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26053000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26053000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Head shower set 286 mm, 1 spray",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set 380 mm, 1 spray",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26071000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26071000/640/26071000.jpg",
		"headline": "Rainshower F-Series 10'",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26071000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26071000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Shower system with safety mixer for wall mounting",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "نظام دش GROHE Euphoria XXL مزود بترموستات ومطلي بطبقة من الكروم وبتصميم هندسي ألماني، إلى جانب أنه مُلحق به دش رأس معدني طوله 310 مم، بالإضافة إلى دش يدوي ثلاثي الرذاذ طوله 110 مم.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Shower system with safety mixer for wall mounting",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "نظام دش GROHE Euphoria Cube XXL 230 مزود بترموستات",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with one valve",
		"textblock_1st_text": "29150LS0",
		"textblock_2nd_text": "ترموستات SuperSteel للدش، أحادي الصمام ويتميز بالتركيب المخفي. مستدير الشكل وأبيض كبياض القمر ومصنوع في ألمانيا بواسطة GROHE. يتسم بأنه صديق للبيئة ومزوَّد بميزة الأمان.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer  for concealed installation with 2 valves",
		"textblock_1st_text": "29151LS0",
		"textblock_2nd_text": "ترموستات Grohtherm SmartControl للدش أو الحمام، ثنائي الصمام للتركيب المخفيّ. مستدير الشكل وأبيض كبياض القمر ومصنوع في ألمانيا بواسطة GROHE. يتسم بأنه صديق للبيئة ومزوَّد بميزة الأمان.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Safety mixer for concealed installation with 3 valves",
		"textblock_1st_text": "29904LS0",
		"textblock_2nd_text": "ترموستات Grohtherm SmartControl للدش أو الحمام، ثلاثي الصمامات للتركيب المخفيّ. مستدير الشكل وأبيض كبياض القمر ومصنوع في ألمانيا بواسطة GROHE. يتسم بأنه صديق للبيئة ومزوَّد بميزة الأمان.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose Twistfree 1250",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "خرطوم GROHE Silver Flex مع موصل دوّار للقيام بخاصية TwistFree، طول 1250 مم",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose Twistfree 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "خرطوم GROHE Silver Flex مزود بموصل دوّار للقيام بخاصية TwistFree، وبطول 1500 مم",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Shower hose Twistfree 1750",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "خرطوم GROHE Silver Flex مزود بموصل دوّار للقيام بخاصية TwistFree، وبطول 1750 مم",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Head shower set ceiling 142 mm, 2 sprays",
		"textblock_1st_text": "26481LS0",
		"textblock_2nd_text": "طقم دش الرأس GROHE Rainshower 310 SmartActive CUBE المزود بخيارين للرذاذ. دش رأس مثبت في السقف بطول 310 مم مزود بذراع دش بطول 142 مم بلمسة نهائية من الكروم ولوحة الرذاذ الأبيض ومربع الشكل. ومصنوع في ألمانيا",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with Safety Mixer for wall mounting",
		"textblock_1st_text": "27615001",
		"textblock_2nd_text": "نظام دش Euphoria 260 من GROHE المزوَّد بترموستات، ودش رأس SmartControl موفِّر للمياه بثلاثة أنماط من الرذاذ ويبلغ طول قطره 260 مم، بالإضافة إلى دش يدوي بثلاثة أنماط من الرذاذ مطليٍّ بالكروم ويبلغ طوله 110 مم. سهل التركيب والتنظيف. تصميم هندسي ألماني",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Safety shower mixer 1/2\" with shower set",
		"textblock_1st_text": "34195001",
		"textblock_2nd_text": "ترموستات الدش Grohtherm 2000 مع مجموعة عمود الدش GROHE Euphoria (ويتكون من دش يدوي 110 مم مع ثلاثة خيارات للرذاذ، عمود 600 مم، خرطوم وصينية 1750 مم)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set with Rainshower SmartActive 310",
		"textblock_1st_text": "34705000",
		"textblock_2nd_text": "طقم دش Grohtherm SmartControl Perfect المزوَّد بترموستات، للتركيب المخفي بثلاثة صمامات ودش رأس ودش يدوي وذراع دش وخرطوم. دائري الشكل. مزوّد بطبقة من الكروم ومصنوع في ألمانيا.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set withRainshower SmartActive 310 Cube",
		"textblock_1st_text": "34706000",
		"textblock_2nd_text": "طقم دش Grohtherm SmartControl Perfect المزوَّد بترموستات، للتركيب المخفي بثلاثة صمامات ودش رأس ودش يدوي وذراع دش وخرطوم. مربع الشكل. مزوّد بطبقة من الكروم ومصنوع في ألمانيا.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34713000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34713000/640/34713000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Combi safety shower mixer with <br />3 valves, exposed/concealed",
		"textblock_1st_text": "34713000",
		"textblock_2nd_text": "ترموستات دش GROHE Grohtherm SmartControl Combi المزود بثلاثة صمامات. مطلي بالكروم ومزود بصينية بيضاء بتصميم هندسي ألماني.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/34713000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "Rapido SmartBox",
		"subheadline": "Universal rough-in box, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Shower rail, 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "Tempesta System 210",
		"subheadline": "Shower system with diverter for wall mounting",
		"textblock_1st_text": "26381001",
		"textblock_2nd_text": "GROHE New Tempesta 210 FLEX Shower System with diverter; compatible with all existing valves for easy upgrades. Made in Germany with 210m two-spray head shower and 100mm hand shower.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Head shower set ceiling 154 mm, 1 spray",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Head shower set ceiling 142 mm, 1 spray",
		"textblock_1st_text": "26067000",
		"textblock_2nd_text": "GROHE Rainshower Cosmopolitan 310, head shower set, ceiling shower arm 142 mm, 9.5 L / min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "Universal rough-in box, 1/2\"",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with Bath Safety Mixer for wall mounting",
		"textblock_1st_text": "27475001",
		"textblock_2nd_text": "GROHE Euphoria 260 Bath/Shower System with thermostat for bathtubs, water saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27473001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27473001/640/27473001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Shower system with single lever mixer for wall mounting",
		"textblock_1st_text": "27473001",
		"textblock_2nd_text": "GROHE Euphoria 260 Shower System with single lever mixer, water-saving SmartControl 260mm 3-spray head shower and 110mm 3-spray hand shower in chrome. German engineering",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/product/27473001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe-gcc.com/ar_sa/our-service/showrooms-installer.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/shower_products_ar_sa.json
// module id = 819
// module chunks = 0